import React from 'react'
import './Avatar.css'
import icon from '../img/person-gy-icon.svg'


function Avatar({mail,logout}){

    return(
            <div className='avatar'>
                <div className='avatar-user'>
                    <img src={icon} alt="Logo" className="logo"/> 
                </div>
                <span><i>{mail}</i></span>
                <div className="out-square logout-btn" onClick={() => { logout('session_id',{path:'/'})}}><b>Salir</b></div>
            </div>
        )
}
export default Avatar